import { RESET } from 'action-creators/generic';
import {
  ReportActions,
  REPORT_SUMMARY_REQUEST,
  REPORT_SUMMARY_SUCCESS,
  REPORT_SUMMARY_LOADING,
} from 'action-creators/reports';
import { ReportSummary, TravelReportRequest } from 'models/reportSummary';

export interface ReportState {
  reportSummary?: ReportSummary;
  isLoading: boolean;
  filters?: TravelReportRequest;
}

const initialState: ReportState = {
  reportSummary: undefined,
  isLoading: false,
  filters: undefined,
};

const reducer = (state = initialState, action: ReportActions): ReportState => {
  switch (action.type) {
    case REPORT_SUMMARY_REQUEST:
      return {
        ...state,
        filters: action.filters,
      };
    case REPORT_SUMMARY_SUCCESS:
      return {
        ...state,
        reportSummary: action.reportSummary,
        isLoading: false,
      };
    case REPORT_SUMMARY_LOADING:
      return {
        ...state,
        isLoading: action.loading,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
